<template>
	<div v-loading="loading" class="self-goods-detail" element-loading-text="正在加载商品详情...">
		<goods-detail-view
			v-if="goodsLoaded"
			:goods-type="1"
			:goods="goodsInfo"
			:cart-loading="addingCart"
			:buy-loading="buyingNow"
			@add-cart="handleAddCart"
			@buy-now="handleBuyNow"
		/>
		<div v-else-if="!loading" class="goods-empty">
			<el-empty description="商品不存在或已下架">
				<el-button type="primary" @click="$router.push('/mallStore/index')">返回服务商城</el-button>
			</el-empty>
		</div>
	</div>
</template>

<script>
	import GoodsDetailView from './components/GoodsDetailView'
	import {
		addMerchantShoppingCart,
		createMerchantCheckout,
		previewMerchantFile,
		queryPublishedMerchantGoodsDetail
	} from '@/api/mall'
	import { createUuid } from '@/utils'

	const DEFAULT_GOODS_IMAGE = require('@/assets/mall/goods/goods-demo.png')

	export default {
		name: 'MallStoreSelfGoodsDetail',
		components: { GoodsDetailView },
		data() {
			return {
				loading: false,
				addingCart: false,
				buyingNow: false,
				checkoutRequestId: createUuid(),
				goodsLoaded: false,
				goodsInfo: {
					goodsId: '',
					title: '',
					introduction: '',
					category: '',
					price: '0.00',
					priceUnit: '元',
					measureUnit: '件',
					shopName: '',
					deliveryText: '',
					deliveryAgreement: '',
					mainImage: DEFAULT_GOODS_IMAGE,
					detailContent: ''
				}
			}
		},
		created() {
			this.loadGoodsDetail()
		},
		methods: {
			async loadGoodsDetail() {
				const goodsId = this.$route.params.id
				this.loading = true
				this.goodsLoaded = false
				try {
					const response = await queryPublishedMerchantGoodsDetail({ id: goodsId })
					const goods = response.data
					if (!goods || Number(goods.goodsType) !== 1) return
					this.goodsInfo = this.mapGoodsDetail(goods)
					this.goodsLoaded = true
				} finally {
					this.loading = false
				}
			},
			mapGoodsDetail(goods) {
				const categories = [goods.categoryFirstName, goods.categorySecondName, goods.categoryThirdName].filter(Boolean)
				return {
					goodsId: goods.id,
					title: goods.goodsTitle || goods.guideTitle || '未命名商品',
					introduction: goods.guideTitle || '',
					category: categories.join(' / ') || '综合服务',
					price: this.formatPrice(goods.sellingPrice),
					priceUnit: goods.priceUnit || '元',
					measureUnit: goods.measureUnit || '件',
					shopName: goods.shopName || '',
					deliveryText: this.formatDeliveryText(goods),
					deliveryAgreement: goods.deliveryAgreement || '',
					mainImage: goods.mainImage ? previewMerchantFile() + goods.mainImage : DEFAULT_GOODS_IMAGE,
					detailContent: goods.goodsDetail || '<p>暂无商品详情</p>'
				}
			},
			formatPrice(value) {
				if (value === undefined || value === null || value === '') return '0.00'
				const price = Number(value)
				return Number.isNaN(price) ? String(value) : price.toFixed(2)
			},
			formatDeliveryText(goods) {
				const deliveryMap = {
					1: '当日发货',
					2: '24小时内发货',
					3: '48小时内发货',
					4: goods.deliveryCustom || '按约定时间发货'
				}
				return deliveryMap[Number(goods.deliveryType)] || goods.deliveryCustom || ''
			},
			// 当前详情页一次加入一件，重复加入由后端累加数量。
			async handleAddCart() {
				if (!this.goodsInfo.goodsId || this.addingCart) return
				this.addingCart = true
				try {
					await addMerchantShoppingCart({ goodsId: this.goodsInfo.goodsId, quantity: 1 })
					this.$modal.msgSuccess('加入购物车成功')
				} finally {
					this.addingCart = false
				}
			},
			// 点击立即购买即生成待支付订单，支付页只读取已经锁定的订单快照。
			async handleBuyNow() {
				if (!this.goodsInfo.goodsId || this.buyingNow) return
				this.buyingNow = true
				try {
					const response = await createMerchantCheckout({
						sourceType: 'BUY_NOW',
						goodsId: this.goodsInfo.goodsId,
						quantity: 1,
						requestId: this.checkoutRequestId
					})
					const payOrderId = response.data && response.data.payOrderId
					if (!payOrderId) throw new Error('创建支付单失败')
					this.$router.push({ name: 'MallStorePayment', query: { payOrderId } })
				} finally {
					this.buyingNow = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.self-goods-detail {
		min-height: 720px;
		background: #f4f7fb;
	}

	.goods-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 620px;
	}
</style>
